import { getPropertyByPath } from "instantsearch.js/es/lib/utils";
const TAG_PLACEHOLDER = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
};
function parseHighlightedAttribute({
  preTag,
  postTag,
  highlightedValue = ""
}) {
  const splitByPreTag = highlightedValue.split(preTag);
  const firstValue = splitByPreTag.shift();
  const elements = firstValue === "" ? [] : [{ value: firstValue, isHighlighted: false }];
  if (postTag === preTag) {
    let isHighlighted = true;
    splitByPreTag.forEach((split) => {
      elements.push({ value: split, isHighlighted });
      isHighlighted = !isHighlighted;
    });
  } else {
    splitByPreTag.forEach((split) => {
      const splitByPostTag = split.split(postTag);
      elements.push({
        value: splitByPostTag[0],
        isHighlighted: true
      });
      if (splitByPostTag[1] !== "") {
        elements.push({
          // Vue removes nodes which are just a single space (vuejs/vue#9208),
          // we replace this by two spaces, which does not have an impact,
          // unless someone would have `white-space: pre` on the highlights
          value: splitByPostTag[1] === " " ? "  " : splitByPostTag[1],
          isHighlighted: false
        });
      }
    });
  }
  return elements;
}
export function parseAlgoliaHit({
  preTag = TAG_PLACEHOLDER.highlightPreTag,
  postTag = TAG_PLACEHOLDER.highlightPostTag,
  highlightProperty,
  attribute,
  hit
}) {
  if (!hit)
    throw new Error("`hit`, the matching record, must be provided");
  const highlightObject = getPropertyByPath(hit[highlightProperty], attribute) || {};
  if (Array.isArray(highlightObject)) {
    return highlightObject.map(
      (item) => parseHighlightedAttribute({
        preTag,
        postTag,
        highlightedValue: unescape(item.value)
      })
    );
  }
  return parseHighlightedAttribute({
    preTag,
    postTag,
    highlightedValue: unescape(highlightObject.value)
  });
}
